import helper from './helper';
import CountUp from 'countup.js';

class HeaderBasket {
    constructor() {
        this.headerCartButton = $('#header-cart');
        this.headerCartIcon = $('#m-header-cart');
        this.helper = helper;
    }

    getStartNum() {
        return this.headerCartButton.attr('data-summ');
    }

    update(count, summ) {
        if (typeof count !== 'number' || typeof summ !== 'number') return;
        let start = parseFloat(this.getStartNum());
        let animateNumber;
        this.headerCartButton.attr('data-count', count);
        this.headerCartButton.attr('data-summ', summ);
        this.headerCartIcon
            .attr('data-count', count)
            .children('.m-shop-header-cart__count')
            .html(count);
        this.headerCartButton
            .children('.shop-header-cart__text')
            .html(
                `${count} ${this.helper.declension(count, [
                    'товар',
                    'товара',
                    'товаров',
                ])} на <span class="number-animate"></span> р.`
            );
        animateNumber = new CountUp(
            this.headerCartButton.find('.number-animate')[0],
            start,
            summ,
            isInt(summ) ? 0 : 2,
            0.5,
            {
                separator: ' ',
                decimal: ',',
            }
        );
        animateNumber.start();
    }
}

function isInt(n) {
    return Number(n) === n && n % 1 === 0;
}

function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
}

export default new HeaderBasket();
